import { render, staticRenderFns } from "./evaluationScore.vue?vue&type=template&id=72a7dfb5&scoped=true&"
import script from "./evaluationScore.vue?vue&type=script&lang=js&"
export * from "./evaluationScore.vue?vue&type=script&lang=js&"
import style0 from "./evaluationScore.vue?vue&type=style&index=0&id=72a7dfb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a7dfb5",
  null
  
)

export default component.exports